<template>
  <div :class="`dplayer-wrapper ${type}`">
    <div id="dplayer" />
    <slot name="cover" :play-end="loadError" />
  </div>
</template>

<script>
import DPlayer from 'dplayer'
import Hls from 'hls.js'
import flvjs from 'flv.js'

import flvPlayer from './flvPlayer'
import hlsPlayer from './hlsPlayer'
import mp4Player from './mp4Player'

// 移除全局变量污染，使用模块化的Hls导入
// window.Hls = Hls
export default {
  name: 'LivePlayer',
  mixins: [flvPlayer, hlsPlayer, mp4Player],
  props: {
    type: {
      type: String,
      default: 'live'
    },
    liveUrl: {
      type: Array,
      default: Array
    }
  },
  data() {
    return {
      dp: null,
      loadError: true,
      timer: null,
      isfullscreen: false,
      defaultOptions: {
        container: '',
        autoplay: false,
        live: false,
        preload: false,
        loop: false,
        video: {
          defaultQuality: 0
        },
        pluginOptions: {}
      }
    }
  },
  watch: {
    liveUrl: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.$nextTick(() => {
            this.init()
          })
        }
      }
    },
    loadError: {
      handler(newVal) {
        if (!newVal) {
          this.$nextTick(() => {
            document.querySelector('.dplayer-wrapper .top-controls') && document.querySelector('#dplayer').appendChild(document.querySelector('.dplayer-wrapper .top-controls'))
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
    if (this.type === 'playback') {
      // console.log('playback')
    } else if (this.type === 'live') {
      if (this.videoFormat('flv')) {
        this.unInstallFlvPlayerEvent()
      } else if (this.videoFormat('m3u8')) {
        this.unInstallHlsEvent()
      }
    }
    this.dp.destroy()
  },
  methods: {
    init() {
      this.defaultOptions.container = document.getElementById('dplayer')
      if (this.type === 'playback') {
        // 回放
        this.defaultOptions.autoplay = false
        this.defaultOptions.live = false
        this.initVideo(this.defaultOptions, this.initDplayer)
      } else if (this.type === 'live') {
        // 趣直播
        this.defaultOptions.live = true
        this.defaultOptions.autoplay = true
        if (this.videoFormat('flv')) {
          this.initFlvPlayer(this.defaultOptions, this.initDplayer)
        } else if (this.videoFormat('m3u8')) {
          this.initHls(this.defaultOptions, this.initDplayer)
        } else {
          this.defaultOptions.video.url = this.filterUrl('.m3u8')
          this.initDplayer()
        }
      }
      try {
        this.registerDplayerEvent()
      } catch (error) {
        console.log(error)
      }
    },
    initDplayer(defaultOptions = this.defaultOptions) {
      this.dp = new DPlayer(defaultOptions)

      this.checkDom('#dplayer video', () => {
        this.$emit('ready', this.dp.video)
      })
    },
    registerDplayerEvent() {
      // 视频初始化完成，可以播放
      this.dp.on('canplay', () => {
        clearTimeout(this.timer)
        this.timer = null
        this.loadError = false
        this.isOnce++
        if (this.type === 'live') {
          this.dp.play()
        }
        this.$emit('canplay')
      })
      this.dp.on('timeupdate', () => {
        this.$emit('timeupdate')
      })
      if (this.type === 'live') {
        this.dp.on('play', () => {
          this.$emit('play')
          // 判断当前缓存内容
          if (this.dp.video.buffered.length) {
            const end = this.dp.video?.buffered?.end(this.dp.video.buffered.length - 1) || 0
            if (end) {
              this.dp.video.currentTime = end - 1 || 0
            }
          }
        })
        // 视频正在播放
        this.dp.on('progress', () => {
          if (this.dp.video.buffered.length) {
            // 追帧方法 大于10秒直接跳过，
            const end = this.dp.video.buffered?.end(0) || 0 // 获取当前buffered值(缓冲区末尾)
            const delta = end - this.dp.video.currentTime // 获取buffered与当前播放位置的差值

            // 延迟过大，通过跳帧的方式更新视频
            if (delta > 10 || delta < 0) {
              this.dp.video.currentTime = this.dp.video.buffered?.end(0) - 1
              return
            }

            // 追帧
            if (delta > 1) {
              this.dp.video.playbackRate = 1.1
            } else {
              this.dp.video.playbackRate = 1
            }
          }
        })
      }
      this.dp.on('ended', () => {
        if (this.type === 'playback') {
          // console.log('playback')
        } else if (this.type === 'live') {
          if (this.videoFormat('flv')) {
            this.flvPlayer.unload()
            this.flvPlayer.load()
          } else if (this.videoFormat('m3u8')) {
            this.unInstallHlsEvent()
          }
        }
        // console.log('ended')
        this.$emit('ended')
      })
      this.dp.on('pause', () => {
        this.$emit('pause')
      })
      this.dp.on('error', () => {
        // console.log('dp-error', e)
        this.loadError = true
        this.reload()
        this.$emit('error')
      })
      this.dp.on('fullscreen', () => {
        this.isfullscreen = true
      })
      this.dp.on('fullscreen_cancel', () => {
        this.isfullscreen = false
      })
    },
    reload() {
      if (this.timer) {
        clearTimeout(this.timer)
        return
      }
      setTimeout(() => {
        // this.dp.switchVideo({url: this.defaultOptions.video.url})
        this.dp?.video?.load()
        this.timer = null
      }, 2000)
    },
    // 判断播放格式
    videoFormat(type) {
      if (type === 'flv') {
        return !!flvjs.isSupported()
      } else if (type === 'm3u8') {
        return Hls.isSupported()
      }
    },

    filterUrl(type) {
      let url = ''
      this.liveUrl.forEach(item => {
        if (item.indexOf(type) !== -1) {
          url = item
        }
      })
      return url
    },
    //  检查dom是否执行完成
    checkDom(className, callback) {
      const dom = document.querySelector(className)
      if (dom) {
        //  执行dom加载完成后的操作
        callback(dom)
        //  清除定时器
        if (!this.timer) {
          clearTimeout(this.timer)
        }
      } else {
        // 自我调用
        this.timer = setTimeout(this.checkDom, 5)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dplayer-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  #dplayer {
    width: 100%;
    height: 100%;
    background-color: #333;
    .top-controls {
      transition: all 0.3s ease;
    }
    & + div {
      // display: none;
    }
    ::v-deep .dplayer-mobile-play {
      background-color: #333;
      border-radius: 50%;
      padding: 5px;
    }
    ::v-deep .dplayer-full-in-icon {
      display: none;
    }
    ::v-deep .dplayer-menu.dplayer-menu-show {
      display: none !important;
    }
    ::v-deep .dplayer-quality {
      display: none !important;
    }
    ::v-deep .dplayer-setting-loop {
      display: none !important;
    }
    ::v-deep .dplayer-setting {
      display: none;
    }
  }
}
.live {
  ::v-deep .dplayer-playing {
    .dplayer-mobile-play {
      display: none;
    }
  }
  ::v-deep .dplayer-hide-controller {
    .top-controls {
      opacity: 0;
      transform: translateY(-100%);
    }
  }
}
</style>
